<div class="dropdown">
	<button type="button" id="budget-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
		data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
		<fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
		Filter
		@if (filterCount > 0) {
			<span class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{ filterCount }}</span>
		}
	</button>

	<div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

		<div class="fs-5 fw-bold px-3 py-2">Filter Options</div>

		<div class="separator border-gray-200"></div>

		<!-- Name Input with Add Button -->
		<div class="mb-2 px-3 py-2 mw-100">
			<label class="form-label fw-semibold">Name:</label>
			<div class="input-group">
				<input type="text" class="form-control form-control-solid" placeholder="Enter name"
					[(ngModel)]="nameInput" (keyup.enter)="addName()" />
				<button class="btn btn-primary px-3" type="button" (click)="addName()">
					<fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
				</button>
			</div>
			<div class="d-flex flex-wrap w-100">
				@if (activeFilter.names && activeFilter.names.length > 0) {
					<div class="mt-2">
						@for (name of activeFilter.names; track $index) {
							<button class="tag-filter btn btn-primary" type="button" (click)="removeName($index)">{{ name }}
								<fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
							</button>
						}
					</div>
				}
			</div>
		</div>

		<!-- Year Range Input -->
		<div class="mb-2 px-3 py-2 mw-100">
			<label class="form-label fw-semibold">Year:</label>
			<div class="row">
				<div class="col-6">
					<input type="number" class="form-control form-control-solid" placeholder="Min"
						[(ngModel)]="minimumYearInput" (change)="onMinYearChange()" />
				</div>
				<div class="col-6">
					<input type="number" class="form-control form-control-solid" placeholder="Max"
						[(ngModel)]="maximumYearInput" (change)="onMaxYearChange()" />
				</div>
			</div>
		</div>

		<!-- Status Multi-select -->
		<div class="mb-2 px-3 py-2">
			<label class="form-label fw-semibold">Status:</label>
			<ms-multi-select placeholder="Select Status" [options]="selectStatusOptions"
				[(selectedOptions)]="selectedStatuses" (selectionChange)="onStatusChange($event)" />
		</div>

		<!-- Actions -->
		<div class="d-flex justify-content-end px-3 py-2">
			<button type="button" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
				(click)="onReset()">Reset</button>
			<button type="button" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
		</div>

	</div>
</div>
